// src/components/CampaignList.js

import React, { useState, useEffect } from 'react';
import { CampaginListHooks } from '../../Helper/CampaginHelper';
import { Link } from 'react-router-dom';
import { hasCreatePermission, hasEditPermission, hasdeletePermission, hasSharePermission } from '../../Utils/PermissionUtils';
import ShareModal from '../../Utils/ShareModal';
import { toast } from 'react-toastify';
import service from '../../Services/service';
import DeleteModal from '../../Utils/DeleteModal';

const CampaignListComponent = () => {
    const [Campaigns, setCampaigns] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState('Name');
    const [sortDescending, setSortDescending] = useState(false);
    const [pageNumber, setPageNumber] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalPages, setTotalPages] = useState(1);
    const [totalitems, setTotalitems] = useState(0);

    const [showModal, setShowModal] = useState(false);
    const [selectedScreenName, setSelectedScreenName] = useState('');
    const [selectedrowId, setSelectedRowId] = useState(0);

    const canEditCampaign = hasEditPermission('Campaign');
    const canDeleteCampaign = hasdeletePermission('Campaign');
    const canShareCampaign = hasSharePermission('Campaign');

    const [deleteId, setDeleteId] = useState(null);
        const [showDeleteModal, setShowDeleteModal] = useState(false);

    useEffect(() => {
        getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize);
    }, [searchTerm, sortBy, sortDescending, pageNumber, pageSize]);

    async function getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize) {
        const data = await CampaginListHooks(searchTerm, sortBy, sortDescending, pageNumber, pageSize);
        if (data) {
            setCampaigns(data.items);
            setTotalPages(data.totalPages);
            setTotalitems(data.totalItems);
        }
    }

    const handleSortChange = (event) => {
        const [field, order] = event.target.value.split('_');
        setSortBy(field);
        setSortDescending(order === 'desc');
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPageNumber(newPage);
        }
    };

    const handleDeleteClick = (id,name) => {
        setSelectedScreenName(name);
            setDeleteId(id);
            setShowDeleteModal(true);
        };
    
        const handleConfirmDelete = async () => {
            try {
                const response = await service.getdata("Campaign/DeleteById?id=" + deleteId);
                if (response !== undefined) {
                    toast.success('Campaign Deleted successfully!');
                    // Replace below with your actual refresh logic
                    getData(searchTerm, sortBy, sortDescending, pageNumber, pageSize);
                }
            } catch (error) {
                toast.error('Error deleting Campaign. Please try again.');
            } finally {
                setShowDeleteModal(false);
            }
        };

    return (
        <div className="container-fluid content-top-gap">
            <nav aria-label="breadcrumb" className="mb-4">
                <ol className="breadcrumb my-breadcrumb">
                    <li className="breadcrumb-item"><a href="/">Home</a></li>
                    <li className="breadcrumb-item active" aria-current="page">Campaign List</li>
                </ol>
            </nav>

            <div className="card card_border mb-4">
                <div className="card-header chart-grid__header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0">Campaign List</h5>
                    {hasCreatePermission('Campaign') && (
                        <Link to="/CreateCampaign" className="btn btn-outline-primary btn-sm">
                            Add Campaign
                        </Link>
                    )}
                </div>

                <div className="card-body">
                    <div className="row mb-3">
                        <div className="col-md-4">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Search by name..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className="col-md-4 mt-2 mt-md-0">
                            <select
                                className="custom-select"
                                onChange={handleSortChange}
                                value={`${sortBy}_${sortDescending ? 'desc' : 'asc'}`}
                            >
                                <option value="Name_asc">Name (A-Z)</option>
                                <option value="Name_desc">Name (Z-A)</option>
                                <option value="CreatedAt_asc">Created At (Oldest)</option>
                                <option value="CreatedAt_desc">Created At (Newest)</option>
                                <option value="UpdatedAt_asc">Updated At (Oldest)</option>
                                <option value="UpdatedAt_desc">Updated At (Newest)</option>
                                <option value="CreatedBy_asc">Created By (A-Z)</option>
                                <option value="CreatedBy_desc">Created By (Z-A)</option>
                            </select>
                        </div>
                        <div className="col-md-4 mt-2 mt-md-0">
                            <select
                                className="custom-select"
                                value={pageSize}
                                onChange={(e) => {
                                    setPageSize(Number(e.target.value));
                                    setPageNumber(1); // reset to page 1
                                }}
                            >
                                <option value={10}>Show 10</option>
                                <option value={20}>Show 20</option>
                                <option value={50}>Show 50</option>
                                <option value={100}>Show 100</option>
                            </select>
                        </div>
                    </div>

                    <table className="table table-striped table-bordered table-hover" style={{ fontSize: '14px' }}>
                        <thead className="bg-light">
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th>Group Layout</th>
                                <th style={{ width: '220px' }}>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Campaigns.map((Campaign, index) => (
                                <tr key={Campaign.campaignId}>
                                    <td>{(pageNumber - 1) * pageSize + index + 1}</td>
                                    <td>{Campaign.name}</td>
                                    <td>{Campaign.layoutGroup}</td>
                                    <td>
                                        <div className="btn-group" role="group">
                                            {canEditCampaign && (
                                                <>
                                                    <Link to={`/EditCampaign/${Campaign.campaignId}`} className="btn btn-outline-info btn-sm" title="Edit Campaign">
                                                        Edit
                                                    </Link>
                                                    <Link to={`/schedule/CreateSchedule`} className="btn btn-outline-primary btn-sm" title="Create Schedule">
                                                        Schedule
                                                    </Link>
                                                </>
                                            )}
                                            
                                            {canDeleteCampaign && (
                                                <Link to="#" className="btn btn-outline-danger btn-sm" title="Delete Campaign" onClick={() => handleDeleteClick(Campaign.campaignId,Campaign.name)} >
                                                    Delete
                                                </Link>
                                            )}
                                            {
                                                canShareCampaign && (
                                                    <Link
                                                        className="btn btn-outline-success btn-sm"
                                                        title="Share"
                                                        onClick={() => {
                                                            setSelectedScreenName(Campaign.name);
                                                            setShowModal(true);
                                                            setSelectedRowId(Campaign.CampaignId);
                                                        }}
                                                    >
                                                        Share
                                                    </Link>
                                                )
                                            }
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="d-flex justify-content-between align-items-center flex-wrap mt-4">

                        <div className="text-muted">
                            Showing{" "}
                            <strong>
                                {(pageNumber - 1) * pageSize + 1}
                            </strong>
                            {" - "}
                            <strong>
                                {Math.min(pageNumber * pageSize, totalitems)}
                            </strong>
                            {" of "}
                            <strong>{totalitems}</strong>
                            {" Campaign's"}
                        </div>

                        <nav>
                            <ul className="pagination pagination-sm mb-0">

                                <li className={`page-item ${pageNumber === 1 ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => setPageNumber(pageNumber - 1)}
                                    >
                                        <i className="fa fa-angle-left"></i>
                                    </button>
                                </li>

                                {Array.from({ length: totalPages }, (_, i) => (
                                    <li
                                        key={i}
                                        className={`page-item ${pageNumber === i + 1 ? "active" : ""
                                            }`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => setPageNumber(i + 1)}
                                        >
                                            {i + 1}
                                        </button>
                                    </li>
                                ))}

                                <li className={`page-item ${pageNumber === totalPages ? "disabled" : ""}`}>
                                    <button
                                        className="page-link"
                                        onClick={() => setPageNumber(pageNumber + 1)}
                                    >
                                        <i className="fa fa-angle-right"></i>
                                    </button>
                                </li>

                            </ul>
                        </nav>

                    </div>
                </div>
            </div>
            <ShareModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                screenName={selectedScreenName}
                moduleId={4}
                rowId={selectedrowId}
            />
             <DeleteModal
                show={showDeleteModal}
                handleClose={() => setShowDeleteModal(false)}
                handleConfirm={handleConfirmDelete}
                message="Are you sure you want to delete this Campaign?"
                itemName={selectedScreenName}
            />
        </div>
    );
};

export default CampaignListComponent;
